module.exports = __webpack_public_path__ + "img/jht-icon-15-act.0721dced.png";